import trackingShoppingMiddleware from '../middlewares/trackingVisitShopping'

const SHOPPING_URL = process.env.VUE_APP_SHOPPING_URL

export default {
  data() {
    return {
      userHasData: null,
      go: null,
      shoppingBaseUrl: SHOPPING_URL + '/autenticar?token=',
      shoppingSupplierUrl: '&returnUrl=/fornecedor/',
      shoppingReturnUrl: '&returnUrl=/meus-pedidos/detalhes/',
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },

    externalToken: {
      get() {
        return this.$store.state.wallet.externalToken
      },
      set(payload) {
        this.$store.dispatch('setExternalToken', payload)
      },
    },

    shoppingUrl() {
      return this.shoppingBaseUrl + this.externalToken
    },
  },

  watch: {
    walletSummary(payload) {
      if (!payload.pending && !payload.loading && !this.view) {
        this.verifyDataUser()
      }
    },
  },

  methods: {
    verifyDataUser() {
      if (
        this.walletSummary.owner_full_name === null &&
        this.walletSummary.owner_cpf === null
      ) {
        return false
      } else {
        return true
      }
    },
    redirectTo() {
      this.go = this.$route.query.go ? this.$route.query.go : null

      if (this.go === 'shopping' && this.verifyDataUser()) {
        return this.go
      } else {
        this.userHasData = 'without data'
        return this.userHasData
      }
    },

    goTo(params, redirectTypeName, order_id) {
      let data = {}
      if (params === 'shopping') {
        window.open(this.$route.path + '?go=shopping')
      } else if (params !== 'shopping' && redirectTypeName === 'suppliers') {
        data = { activity: `visit_supplier_${params}` }
        trackingShoppingMiddleware(data)
        window.open(this.shoppingUrl + this.shoppingSupplierUrl + params)
      } else {
        data = { activity: 'visit_orders' }
        trackingShoppingMiddleware(data)
        window.open(
          this.shoppingUrl +
            this.externalToken +
            this.shoppingReturnUrl +
            order_id
        )
      }
    },

    firstAccessWallet() {
      document.location.reload(true)
    },
  },
}
